import classNames from 'classnames';
import { Link, LinkProps } from 'react-router-dom';
import { Button } from 'yoso';
import { MaintenanceErrorMessageProps } from '~/components/Error/Message/Maintenance/MaintenanceErrorMessage';
import { ErrorMessage } from '~/components/Error/Message/v2/ErrorMessage';
import { T, t } from '~/components/I18n';
import { Siren } from '~/components/Icon/Siren';
import { regularFormat } from '~/components/Util';
import styles from './MaintenanceErrorMessage.module.scss';

export type PartialMaintenanceErrorMessageProps = MaintenanceErrorMessageProps;

export const PartialMaintenanceErrorMessage = ({
  className,
  error,
}: PartialMaintenanceErrorMessageProps) => {
  const { startAt, endAt } = error.payload?.response?.data.responseData || {};
  return (
    <ErrorMessage
      className={classNames(styles.root, className)}
      icon={<Siren width="100" height="100" alt={t('citizen_maintenance_title')} />}
      title={t('citizen_maintenance_title')}
      description={
        <>
          <T name="citizen_spec_maintenance_desc" />
          <span className={styles.period}>
            {regularFormat(startAt, { format: 'PP p' })} ~{' '}
            {regularFormat(endAt, { format: 'PP p' })}
          </span>
        </>
      }>
      <Button<LinkProps> as={Link} to="/" size="large" color="primary">
        <T name="citizen_homebutton" />
      </Button>
    </ErrorMessage>
  );
};
